import React, { useState } from 'react'
import { format } from 'date-fns'

import { LgyField, LGYAddress } from 'app/components/util/lgy-field/LgyField'
import { FaPlus, FaMinus } from 'react-icons/fa'

const Condo = ({ firstLineName, developmentBusinessId, secondLineName, city, state, zipCode, zipPlusFour,
  county, dispositionCode, approvalRequestRecievedDate, reviewCompletedDate }) => {
  const [details, toggleDetails] = useState(false)

  return <div className='usa-width-one-whole'>
    {!details ?
      <span className='condo-summary'>
        {firstLineName} ({developmentBusinessId})
        <button type='button' aria-label={`Open detail view for ${Condo.firstLineName}`} onClick={() => toggleDetails(!details)}>
          <FaPlus color='black' size='20' />
        </button>
      </span>
      : <div className='condo-details'>
        <div className='usa-width-one-half'>
          <LgyField label='Name (ID)' value={`${firstLineName} (${developmentBusinessId})`} />
          <LgyField label='Address'>
            <LGYAddress
              streetAddress1={secondLineName}
              city={city}
              state={state}
              zip={zipCode}
              zipSuffix={zipPlusFour}
              county={county} />
          </LgyField>
        </div>
        <div className='usa-width-one-third'>
          <LgyField label='Status' value={dispositionCode} />
          <LgyField label='Request Received Date' value={approvalRequestRecievedDate ? format(approvalRequestRecievedDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true }) : 'Unavailable'} />
          <LgyField label='Review Completion Date' value={reviewCompletedDate ? format(reviewCompletedDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true }) : 'Unavailable'} />
        </div>
        <button type='button' aria-label={`Close detail view for ${Condo.firstLineName}`} onClick={() => toggleDetails(!details)}>
          <FaMinus color='black' size='20' />
        </button>
      </div>}
  </div>
}

export default Condo
